import { useEffect, useRef, useState } from 'react';

interface Depoimento {
  id: number;
  nome: string;
  idade: string;
  cidade: string;
  foto: string;
  texto: string;
  destaque: string;
  tempoUsando: string;
  transformacao: string;
}

const depoimentos: Depoimento[] = [
  {
    id: 1,
    nome: 'Mariana Oliveira',
    idade: '34 anos',
    cidade: 'São Paulo, SP',
    foto: 'https://public.readdy.ai/ai/img_res/bff7c8774e99f08a1a2ae637089c650d.jpg',
    texto: 'Eu vivia presa em um ciclo de ansiedade que me impedia de dormir, de trabalhar, de viver. Depois de anos tentando terapias convencionais sem resultado duradouro, encontrei o Carta do Eu Futuro. A primeira carta que escrevi para mim mesma me fez chorar por horas — mas foi um choro de libertação. Hoje, 8 meses depois, eu acordo todos os dias com uma clareza que nunca tive. Meus relacionamentos melhoraram, minha carreira decolou e, pela primeira vez, eu gosto de quem eu vejo no espelho.',
    destaque: 'Pela primeira vez, eu gosto de quem eu vejo no espelho.',
    tempoUsando: '8 meses',
    transformacao: 'Ansiedade crônica → Paz interior',
  },
  {
    id: 2,
    nome: 'Carlos Eduardo Santos',
    idade: '41 anos',
    cidade: 'Belo Horizonte, MG',
    foto: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20handsome%20Brazilian%20man%20in%20his%20early%20forties%20with%20warm%20studio%20lighting%2C%20short%20dark%20hair%2C%20trimmed%20beard%2C%20genuine%20warm%20smile%2C%20dark%20sophisticated%20background%20with%20golden%20tones%2C%20professional%20headshot%2C%20confident%20and%20serene%20expression&width=200&height=200&seq=depoimento-carlos-002&orientation=squarish',
    texto: 'Perdi meu pai aos 38 anos e entrei em uma depressão profunda. Não conseguia mais ser o pai que meus filhos precisavam. Um amigo me indicou o Carta do Eu Futuro e, sinceramente, eu não acreditava que algo assim pudesse funcionar. Mas a técnica de escrever para o meu eu futuro mexeu com algo dentro de mim que eu não sabia que existia. Comecei a enxergar possibilidades onde antes só via escuridão. Hoje sou um pai presente, um marido melhor e um homem que finalmente fez as pazes com a saudade.',
    destaque: 'Comecei a enxergar possibilidades onde antes só via escuridão.',
    tempoUsando: '1 ano',
    transformacao: 'Depressão profunda → Vida plena',
  },
  {
    id: 3,
    nome: 'Fernanda Lima',
    idade: '28 anos',
    cidade: 'Curitiba, PR',
    foto: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Brazilian%20woman%20in%20her%20late%20twenties%20with%20soft%20natural%20golden%20hour%20lighting%2C%20straight%20dark%20hair%2C%20warm%20genuine%20smile%20showing%20teeth%2C%20elegant%20minimal%20background%20with%20warm%20tones%2C%20professional%20photography%2C%20hopeful%20and%20vibrant%20expression&width=200&height=200&seq=depoimento-fernanda-003&orientation=squarish',
    texto: 'Eu tinha síndrome do pânico desde os 19 anos. Deixei de viajar, de sair com amigos, de viver. Quando li a história da Bia, senti que alguém finalmente me entendia. Comecei o programa com medo, mas cada carta que eu escrevia era como tirar um peso das costas. A meditação guiada mudou minhas noites — eu que não dormia sem remédio, hoje durmo como um bebê. Minha família não acredita na transformação. Eu mesma às vezes não acredito.',
    destaque: 'Eu que não dormia sem remédio, hoje durmo como um bebê.',
    tempoUsando: '6 meses',
    transformacao: 'Síndrome do pânico → Liberdade total',
  },
  {
    id: 4,
    nome: 'Roberta Mendes',
    idade: '52 anos',
    cidade: 'Salvador, BA',
    foto: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20mature%20elegant%20Brazilian%20woman%20in%20her%20fifties%20with%20beautiful%20warm%20golden%20lighting%2C%20curly%20dark%20hair%20with%20some%20gray%20highlights%2C%20wise%20and%20warm%20smile%2C%20sophisticated%20dark%20background%20with%20amber%20tones%2C%20professional%20headshot%2C%20graceful%20and%20empowered%20expression&width=200&height=200&seq=depoimento-roberta-004&orientation=squarish',
    texto: 'Aos 50 anos eu achava que já era tarde demais para mudar. Carreguei traumas da infância a vida inteira e aprendi a conviver com a dor como se fosse normal. O Carta do Eu Futuro me mostrou que nunca é tarde. A carta que escrevi para a Roberta de 5 anos foi o momento mais poderoso da minha vida. Eu me perdoei, perdoei quem me machucou e finalmente me libertei. Hoje viajo sozinha, comecei um negócio próprio e vivo a melhor fase da minha vida.',
    destaque: 'Aos 50 anos, descobri que nunca é tarde demais para se libertar.',
    tempoUsando: '1 ano e 3 meses',
    transformacao: 'Traumas de infância → Recomeço aos 50',
  },
  {
    id: 5,
    nome: 'Lucas Ferreira',
    idade: '36 anos',
    cidade: 'Florianópolis, SC',
    foto: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20Brazilian%20man%20in%20his%20mid%20thirties%20with%20natural%20warm%20lighting%2C%20short%20brown%20hair%2C%20light%20stubble%2C%20calm%20and%20genuine%20smile%2C%20soft%20dark%20background%20with%20golden%20warm%20tones%2C%20professional%20headshot%20photography%2C%20peaceful%20and%20grounded%20expression&width=200&height=200&seq=depoimento-lucas-005&orientation=squarish',
    texto: 'Eu era cético. Muito cético. Achava que escrever cartas era coisa de filme. Mas minha esposa insistiu e eu resolvi tentar. Na terceira semana, algo mudou. Eu comecei a entender padrões de comportamento que repetia há anos sem perceber. O Caderno da Gratidão virou meu ritual matinal e as cartas para o meu eu futuro me deram uma direção que nenhum coach ou livro de autoajuda conseguiu. Hoje recomendo para todos os meus amigos — inclusive os mais céticos.',
    destaque: 'As cartas me deram uma direção que nenhum coach conseguiu.',
    tempoUsando: '10 meses',
    transformacao: 'Cético total → Defensor apaixonado',
  },
  {
    id: 6,
    nome: 'Ana Beatriz Costa',
    idade: '45 anos',
    cidade: 'Rio de Janeiro, RJ',
    foto: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20beautiful%20Brazilian%20woman%20in%20her%20mid%20forties%20with%20elegant%20warm%20golden%20lighting%2C%20dark%20hair%20pulled%20back%2C%20serene%20confident%20smile%2C%20luxurious%20dark%20background%20with%20soft%20amber%20bokeh%2C%20professional%20headshot%20style%2C%20empowered%20and%20radiant%20expression&width=200&height=200&seq=depoimento-ana-006&orientation=squarish',
    texto: 'Depois de um divórcio devastador, eu perdi minha identidade. Não sabia mais quem eu era fora do casamento. O Carta do Eu Futuro me ajudou a me reencontrar. Cada carta era uma conversa comigo mesma que eu nunca tinha tido coragem de ter. Descobri sonhos que tinha enterrado, talentos que tinha ignorado e uma força que não sabia que existia. Hoje sou uma mulher completa — não porque encontrei alguém, mas porque finalmente me encontrei.',
    destaque: 'Sou completa não porque encontrei alguém, mas porque me encontrei.',
    tempoUsando: '11 meses',
    transformacao: 'Identidade perdida → Mulher completa',
  },
];

const DepoimentosSection = () => {
  const [visibleCards, setVisibleCards] = useState<Set<number>>(new Set());
  const [expandedCard, setExpandedCard] = useState<number | null>(null);
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const cardsRef = useRef<Map<number, HTMLDivElement>>(new Map());
  const sectionRef = useRef<HTMLDivElement>(null);
  const [sectionVisible, setSectionVisible] = useState(false);

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setSectionVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) sectionObserver.observe(sectionRef.current);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.getAttribute('data-idx'));
            if (!Number.isNaN(idx)) {
              setVisibleCards((prev) => new Set(prev).add(idx));
            }
          }
        });
      },
      { threshold: 0.15 }
    );

    cardsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      sectionObserver.disconnect();
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-luxury-black py-24 relative overflow-hidden"
    >
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-32 left-20 w-80 h-80 bg-gold-500 rounded-full blur-[140px]"></div>
        <div className="absolute bottom-20 right-32 w-96 h-96 bg-gold-600 rounded-full blur-[160px]"></div>
      </div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        {/* Header */}
        <div
          className={`text-center mb-20 transition-all duration-1000 ${
            sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-gold-500/40"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-500/60">
              Vidas Transformadas
            </span>
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-gold-500/40"></div>
          </div>

          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white font-light mb-6">
            Histórias <span className="italic text-gold-400">reais</span> de quem{' '}
            <span className="italic text-gold-400">renasceu</span>
          </h2>

          <p className="font-['Montserrat'] text-sm text-white/40 max-w-2xl mx-auto leading-relaxed font-light tracking-wide">
            Cada depoimento aqui é de uma pessoa real que decidiu reescrever sua história.
            Pessoas que, assim como a Bia, encontraram no Carta do Eu Futuro o caminho para a liberdade.
          </p>

          {/* Stats bar */}
          <div className="flex items-center justify-center gap-8 lg:gap-16 mt-12">
            <div className="text-center">
              <p className="font-['Playfair_Display'] text-3xl lg:text-4xl text-gold-400 font-light">2.847</p>
              <p className="font-['Montserrat'] text-[10px] text-white/30 uppercase tracking-[0.2em] mt-1">Vidas transformadas</p>
            </div>
            <div className="w-px h-12 bg-gold-500/15"></div>
            <div className="text-center">
              <p className="font-['Playfair_Display'] text-3xl lg:text-4xl text-gold-400 font-light">97%</p>
              <p className="font-['Montserrat'] text-[10px] text-white/30 uppercase tracking-[0.2em] mt-1">Relatam melhora</p>
            </div>
            <div className="w-px h-12 bg-gold-500/15"></div>
            <div className="text-center">
              <p className="font-['Playfair_Display'] text-3xl lg:text-4xl text-gold-400 font-light">4.9</p>
              <p className="font-['Montserrat'] text-[10px] text-white/30 uppercase tracking-[0.2em] mt-1">Avaliação média</p>
            </div>
          </div>
        </div>

        {/* Depoimentos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {depoimentos.map((dep, index) => {
            const isVisible = visibleCards.has(index);
            const isExpanded = expandedCard === index;
            const isHovered = hoveredCard === index;
            const textoResumo = dep.texto.length > 180 ? dep.texto.slice(0, 180) + '...' : dep.texto;

            return (
              <div
                key={dep.id}
                data-idx={index}
                ref={(el) => {
                  if (el) cardsRef.current.set(index, el);
                }}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
                className={`
                  group relative bg-gradient-to-br from-white/[0.04] to-white/[0.01]
                  border rounded-xl p-7 lg:p-8 backdrop-blur-sm
                  transition-all duration-700 overflow-hidden
                  ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}
                  ${isHovered
                    ? 'border-gold-500/40 shadow-[0_0_50px_rgba(201,168,76,0.12),0_0_100px_rgba(201,168,76,0.05)]'
                    : 'border-gold-500/10 hover:border-gold-500/25'
                  }
                `}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                {/* Golden shimmer sweep on hover */}
                <div
                  className="absolute inset-0 pointer-events-none transition-transform duration-1000 ease-out"
                  style={{
                    background: 'linear-gradient(105deg, transparent 40%, rgba(201,168,76,0.08) 50%, transparent 60%)',
                    transform: isHovered ? 'translateX(200%)' : 'translateX(-200%)',
                  }}
                />

                {/* Golden glow orb behind card on hover */}
                <div
                  className="absolute -inset-1 rounded-xl pointer-events-none transition-opacity duration-700"
                  style={{
                    background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.06) 0%, transparent 70%)',
                    opacity: isHovered ? 1 : 0,
                  }}
                />

                {/* Top golden line that animates on hover */}
                <div
                  className="absolute top-0 left-1/2 -translate-x-1/2 h-[2px] bg-gradient-to-r from-transparent via-gold-500/60 to-transparent rounded-full transition-all duration-700 ease-out"
                  style={{
                    width: isHovered ? '80%' : '0%',
                    opacity: isHovered ? 1 : 0,
                  }}
                />

                {/* Transformação badge */}
                <div className="flex items-center gap-2 mb-6 relative z-10">
                  <span
                    className={`font-['Montserrat'] text-[9px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full border transition-all duration-500 ${
                      isHovered
                        ? 'text-gold-400 bg-gold-500/15 border-gold-500/30'
                        : 'text-gold-500/70 bg-gold-500/10 border-gold-500/15'
                    }`}
                  >
                    {dep.transformacao}
                  </span>
                </div>

                {/* Aspas decorativas with pulse on hover */}
                <div className="mb-4 relative z-10">
                  <i
                    className={`ri-double-quotes-l text-3xl transition-all duration-500 ${
                      isHovered ? 'text-gold-500/40 scale-110' : 'text-gold-500/15 scale-100'
                    }`}
                    style={{ display: 'inline-block', transformOrigin: 'left bottom' }}
                  ></i>
                  {/* Golden dot pulse */}
                  <div
                    className="absolute -top-1 left-6 w-1.5 h-1.5 bg-gold-500/60 rounded-full transition-all duration-500"
                    style={{
                      opacity: isHovered ? 1 : 0,
                      transform: isHovered ? 'scale(1)' : 'scale(0)',
                      boxShadow: isHovered ? '0 0 8px rgba(201,168,76,0.5)' : 'none',
                    }}
                  />
                </div>

                {/* Texto do depoimento */}
                <p className="font-['Montserrat'] text-xs text-white/45 leading-[1.9] font-light tracking-wide mb-4 relative z-10">
                  {isExpanded ? dep.texto : textoResumo}
                </p>

                {dep.texto.length > 180 && (
                  <button
                    onClick={() => setExpandedCard(isExpanded ? null : index)}
                    className="font-['Montserrat'] text-[10px] text-gold-400/70 hover:text-gold-400 uppercase tracking-[0.2em] mb-5 cursor-pointer transition-colors duration-300 flex items-center gap-1.5 whitespace-nowrap relative z-10"
                  >
                    {isExpanded ? 'Ler menos' : 'Ler mais'}
                    <i className={`ri-arrow-${isExpanded ? 'up' : 'down'}-s-line text-sm`}></i>
                  </button>
                )}

                {/* Destaque */}
                <div
                  className={`relative pl-4 mb-7 transition-all duration-500 z-10 ${
                    isHovered ? 'border-l-2 border-gold-400/50' : 'border-l-2 border-gold-500/30'
                  }`}
                >
                  <p
                    className={`font-['Playfair_Display'] text-sm italic leading-relaxed transition-colors duration-500 ${
                      isHovered ? 'text-gold-400/90' : 'text-gold-400/70'
                    }`}
                  >
                    &ldquo;{dep.destaque}&rdquo;
                  </p>
                </div>

                {/* Divider */}
                <div
                  className="w-full h-px mb-6 transition-all duration-700 relative z-10"
                  style={{
                    background: isHovered
                      ? 'linear-gradient(to right, transparent, rgba(201,168,76,0.35), transparent)'
                      : 'linear-gradient(to right, transparent, rgba(201,168,76,0.15), transparent)',
                  }}
                ></div>

                {/* Autor */}
                <div className="flex items-center gap-4 relative z-10">
                  <div
                    className={`w-12 h-12 rounded-full overflow-hidden flex-shrink-0 transition-all duration-500 ${
                      isHovered
                        ? 'border-2 border-gold-500/50 shadow-[0_0_15px_rgba(201,168,76,0.2)]'
                        : 'border-2 border-gold-500/20'
                    }`}
                  >
                    <img
                      src={dep.foto}
                      alt={dep.nome}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="font-['Playfair_Display'] text-sm text-white font-semibold truncate">
                      {dep.nome}
                    </p>
                    <p className="font-['Montserrat'] text-[10px] text-white/30 tracking-wide">
                      {dep.idade} · {dep.cidade}
                    </p>
                  </div>
                </div>

                {/* Tempo usando */}
                <div className="absolute top-7 right-7 flex items-center gap-1.5 z-10">
                  <i className="ri-time-line text-xs text-gold-500/30"></i>
                  <span className="font-['Montserrat'] text-[9px] text-gold-500/40 tracking-wider">
                    {dep.tempoUsando}
                  </span>
                </div>

                {/* Estrelas with hover glow */}
                <div className="flex items-center gap-0.5 mt-4 relative z-10">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-xs transition-all duration-500 ${
                        isHovered ? 'text-gold-500/80' : 'text-gold-500/50'
                      }`}
                      style={{
                        transitionDelay: isHovered ? `${i * 60}ms` : '0ms',
                        textShadow: isHovered ? '0 0 6px rgba(201,168,76,0.4)' : 'none',
                      }}
                    ></i>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA bottom */}
        <div
          className={`text-center mt-20 transition-all duration-1000 delay-500 ${
            sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="inline-flex flex-col items-center gap-6 bg-gradient-to-br from-gold-500/10 to-transparent border border-gold-500/15 rounded-2xl px-12 py-10 backdrop-blur-sm">
            <div className="flex items-center gap-2">
              <i className="ri-heart-pulse-fill text-lg text-gold-500/60"></i>
              <span className="font-['Montserrat'] text-xs text-gold-400/60 uppercase tracking-[0.25em]">
                Sua história pode ser a próxima
              </span>
              <i className="ri-heart-pulse-fill text-lg text-gold-500/60"></i>
            </div>
            <p className="font-['Playfair_Display'] text-2xl lg:text-3xl text-white font-light">
              Pronto para <span className="italic text-gold-400">reescrever</span> sua história?
            </p>
            <a
              href="/"
              className="group bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-sm px-10 py-4 rounded-lg hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all duration-500 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer tracking-wider uppercase"
            >
              Começar minha transformação
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-2 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DepoimentosSection;
